export function formatAttributesFilters(
  filters: Record<string, string[]>
): string | undefined {
  if (Object.values(filters || {}).length === 0) return undefined;

  return Object.entries(filters).reduce((acc, selectedFilter) => {
    const [id, optionIds] = selectedFilter as unknown as [number, string[]];

    if ((optionIds || []).length === 0) return acc;

    const formattedAttributeFilter = `${id}=${optionIds.join('|')}`;

    return `${acc}${acc ? ',' : ''}${formattedAttributeFilter}`;
  }, '');
}
